module.exports = __webpack_public_path__ + "img/flag_de.317679fe.svg";